(() => {
  const SELECTOR = '[data-cart-expected-delivery]';
  const TZ = 'Europe/Sofia';
  const CUT_OFF_HOUR = 12;
  const CONFIG_URL = 'https://admin.feelyou.bg/delivery-promise/theme-config?store_key=target_2';
  const CART_SNAPSHOT_ENABLED = true;
  const SNAPSHOT_VERSION = 'cart_expected_delivery_v1';

  const CONFIG = {
    mode: 'EU_PROFILE_COUNTRY',
    profiles: {
      EXPRESS: { min: 0, max: 1 },
      STANDARD: { min: 2, max: 4 },
      RO_FAST: { min: 3, max: 6 },
      GROUP_5_8: { min: 5, max: 8 },
      BTS: { min: 10, max: 14 }
    },
    transit: {
      DEFAULT: { min: 4, max: 7 },
      GR: { min: 2, max: 5 },
      RO: { min: 2, max: 5 },
      HR: { min: 2, max: 5 },
      HU: { min: 3, max: 6 },
      SI: { min: 3, max: 5 },
      SK: { min: 3, max: 5 },
      PL: { min: 3, max: 6 },
      IT: { min: 4, max: 7 },
      FR: { min: 5, max: 8 },
      DE: { min: 5, max: 8 },
      AT: { min: 5, max: 8 },
      BE: { min: 5, max: 8 },
      LT: { min: 5, max: 8 },
      LV: { min: 5, max: 8 },
      EE: { min: 5, max: 8 },
      NL: { min: 5, max: 8 },
      LU: { min: 5, max: 8 },
      MT: { min: 5, max: 8 },
      PT: { min: 6, max: 9 },
      ES: { min: 6, max: 9 }
    }
  };

  let remoteConfigPromise = null;

  function mergeConfig(remote) {
    if (!remote || remote.ok === false || remote.is_active === false) return CONFIG;
    return {
      mode: remote.mode || CONFIG.mode,
      profiles: Object.assign({}, CONFIG.profiles, remote.profiles || {}),
      transit: Object.assign({}, CONFIG.transit, remote.transit || {})
    };
  }

  function loadConfig() {
    if (remoteConfigPromise) return remoteConfigPromise;
    if (!window.fetch) {
      remoteConfigPromise = Promise.resolve(CONFIG);
      return remoteConfigPromise;
    }

    remoteConfigPromise = Promise.race([
      fetch(CONFIG_URL, { credentials: 'omit', cache: 'no-store' })
        .then((response) => response.ok ? response.json() : null)
        .then(mergeConfig)
        .catch(() => CONFIG),
      new Promise((resolve) => setTimeout(() => resolve(CONFIG), 1200))
    ]);

    return remoteConfigPromise;
  }

  const pad2 = (n) => String(n).padStart(2, '0');
  const fmtDM = (d) => `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}`;
  const fmtISODate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;

  function nowInTZ(tz) {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: tz })); }
    catch (e) { return new Date(); }
  }

  function orthodoxEasterSunday(y) {
    const a = y % 4, b = y % 7, c = y % 19;
    const d = (19 * c + 15) % 30;
    const e = (2 * a + 4 * b - d + 34) % 7;
    const m = Math.floor((d + e + 114) / 31);
    const day = ((d + e + 114) % 31) + 1;
    const dt = new Date(y, m - 1, day);
    dt.setDate(dt.getDate() + 13);
    return dt;
  }

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  function bgHolidays(y) {
    const fixed = [
      new Date(y, 0, 1), new Date(y, 2, 3),
      new Date(y, 4, 1), new Date(y, 4, 6), new Date(y, 4, 24),
      new Date(y, 8, 6), new Date(y, 8, 22),
      new Date(y, 11, 24), new Date(y, 11, 25), new Date(y, 11, 26)
    ];
    const easter = orthodoxEasterSunday(y);
    const gf = new Date(easter); gf.setDate(gf.getDate() - 2);
    const gs = new Date(easter); gs.setDate(gs.getDate() - 1);
    const em = new Date(easter); em.setDate(easter.getDate() + 1);
    const base = fixed.concat([gf, gs, easter, em]);
    const all = base.slice();
    base.forEach((h) => {
      if (isWeekend(h)) {
        const obs = new Date(h);
        do { obs.setDate(obs.getDate() + 1); }
        while (isWeekend(obs) || base.some((x) => x.getTime() === obs.getTime()));
        if (!all.some((x) => x.getTime() === obs.getTime())) all.push(obs);
      }
    });
    return all;
  }

  function makeCalendar(now) {
    const y = now.getFullYear();
    const hol = bgHolidays(y).concat(bgHolidays(y + 1));
    function isHoliday(d) {
      for (let i = 0; i < hol.length; i++) if (sameDay(hol[i], d)) return true;
      return false;
    }
    function isBusiness(d) { return !isWeekend(d) && !isHoliday(d); }
    function nextBusinessDay(d) {
      const x = new Date(d);
      while (!isBusiness(x)) x.setDate(x.getDate() + 1);
      return x;
    }
    function addBusinessDaysFrom(base, days) {
      let d = new Date(base);
      d.setDate(d.getDate() + 1);
      let added = 0;
      while (added < days) {
        if (isBusiness(d)) added++;
        if (added < days) d.setDate(d.getDate() + 1);
      }
      while (!isBusiness(d)) d.setDate(d.getDate() + 1);
      return d;
    }
    return { isBusiness, nextBusinessDay, addBusinessDaysFrom };
  }

  const i18n = {
    bg:{ title:'Очаквана доставка', label:'Очаквана доставка', between:'Доставка между', calculating:'изчисляване…', bts_note:'Продукт по заявка, изпраща се от Испания. Поради това срокът за доставка е по-дълъг. За този продукт не се предлага наложен платеж.' },
    en:{ title:'Estimated delivery', label:'Estimated delivery', between:'Delivery between', calculating:'calculating…', bts_note:'Made-to-order product shipped from Spain. Delivery takes longer. Cash on delivery is not available for this product.' },
    de:{ title:'Voraussichtliche Lieferung', label:'Voraussichtliche Lieferung', between:'Lieferung zwischen', calculating:'Berechnung…', bts_note:'Produkt auf Bestellung, Versand aus Spanien. Die Lieferzeit ist länger. Nachnahme ist für dieses Produkt nicht verfügbar.' },
    it:{ title:'Consegna stimata', label:'Consegna stimata', between:'Consegna tra', calculating:'calcolo…', bts_note:'Prodotto su richiesta spedito dalla Spagna. I tempi di consegna sono più lunghi. Il contrassegno non è disponibile per questo prodotto.' },
    fr:{ title:'Livraison estimée', label:'Livraison estimée', between:'Livraison entre', calculating:'calcul…', bts_note:'Produit sur commande expédié d’Espagne. Le délai est plus long. Le paiement à la livraison n’est pas disponible pour ce produit.' },
    el:{ title:'Εκτιμώμενη παράδοση', label:'Εκτιμώμενη παράδοση', between:'Παράδοση μεταξύ', calculating:'υπολογισμός…', bts_note:'Προϊόν κατά παραγγελία από την Ισπανία. Ο χρόνος παράδοσης είναι μεγαλύτερος. Δεν διατίθεται αντικαταβολή για αυτό το προϊόν.' },
    ro:{ title:'Livrare estimată', label:'Livrare estimată', between:'Livrare între', calculating:'se calculează…', bts_note:'Produs la comandă expediat din Spania. Livrarea durează mai mult. Rambursul nu este disponibil pentru acest produs.' },
    hr:{ title:'Procijenjena dostava', label:'Procijenjena dostava', between:'Dostava između', calculating:'izračun…', bts_note:'Proizvod po narudžbi šalje se iz Španjolske. Rok isporuke je dulji. Plaćanje pouzećem nije dostupno za ovaj proizvod.' },
    sk:{ title:'Odhadované doručenie', label:'Odhadované doručenie', between:'Doručenie medzi', calculating:'výpočet…', bts_note:'Produkt na objednávku odosielaný zo Španielska. Doručenie trvá dlhšie. Dobierka nie je pre tento produkt dostupná.' },
    sl:{ title:'Predvidena dostava', label:'Predvidena dostava', between:'Dostava med', calculating:'izračun…', bts_note:'Izdelek po naročilu, pošiljanje iz Španije. Dostavni rok je daljši. Plačilo po povzetju ni na voljo za ta izdelek.' },
    hu:{ title:'Várható kézbesítés', label:'Várható kézbesítés', between:'Kézbesítés között', calculating:'számítás…', bts_note:'Rendelésre készülő termék Spanyolországból. A szállítás hosszabb ideig tart. Utánvét nem elérhető ehhez a termékhez.' },
    pl:{ title:'Szacowana dostawa', label:'Szacowana dostawa', between:'Dostawa między', calculating:'obliczanie…', bts_note:'Produkt na zamówienie, wysyłany z Hiszpanii. Czas dostawy jest dłuższy. Płatność za pobraniem nie jest dostępna dla tego produktu.' },
    pt:{ title:'Entrega estimada', label:'Entrega estimada', between:'Entrega entre', calculating:'a calcular…', bts_note:'Produto por encomenda enviado de Espanha. O prazo de entrega é mais longo. O pagamento à cobrança não está disponível para este produto.' },
    es:{ title:'Entrega estimada', label:'Entrega estimada', between:'Entrega entre', calculating:'calculando…', bts_note:'Producto bajo pedido enviado desde España. El plazo de entrega es más largo. No está disponible el pago contra reembolso para este producto.' },
    nl:{ title:'Geschatte levering', label:'Geschatte levering', between:'Levering tussen', calculating:'berekenen…', bts_note:'Product op bestelling, verzonden vanuit Spanje. De levertijd is langer. Rembours is niet beschikbaar voor dit product.' },
    lt:{ title:'Numatomas pristatymas', label:'Numatomas pristatymas', between:'Pristatymas tarp', calculating:'skaičiuojama…', bts_note:'Gaminys pagal užsakymą siunčiamas iš Ispanijos. Pristatymo laikas ilgesnis. Apmokėjimas pristatymo metu (COD) šiam gaminiui negalimas.' },
    lv:{ title:'Paredzamā piegāde', label:'Paredzamā piegāde', between:'Piegāde starp', calculating:'aprēķina…', bts_note:'Produkts pēc pasūtījuma tiek sūtīts no Spānijas. Piegādes laiks ir ilgāks. Apmaksa pie saņemšanas (COD) šim produktam nav pieejama.' },
    et:{ title:'Eeldatav tarne', label:'Eeldatav tarne', between:'Tarne vahemikus', calculating:'arvutamine…', bts_note:'Tellimustoode saadetakse Hispaaniast. Tarneaeg on pikem. Sularaha kättesaamisel (COD) ei ole selle toote puhul saadaval.' },
    mt:{ title:'Kunsinna stmata', label:'Kunsinna stmata', between:'Kunsinna bejn', calculating:'qed jiġi kkalkulat…', bts_note:'Prodott magħmul fuq ordni mibgħut minn Spanja. Il-ħin tal-kunsinna huwa itwal. Ħlas mal-kunsinna (COD) mhuwiex disponibbli għal dan il-prodott.' }
  };

  function pickLang(l) {
    if (!l) return 'en';
    l = String(l).toLowerCase();
    if (i18n[l]) return l;
    const base = l.split('-')[0];
    return i18n[base] ? base : 'en';
  }

  function promiseFor(profileKey, country, config) {
    const source = config || CONFIG;
    const profile = source.profiles[profileKey] || source.profiles.STANDARD;
    const transit = source.transit[country] || source.transit.DEFAULT || { min: 0, max: 0 };
    return {
      min: Number(profile.min || 0) + Number(transit.min || 0),
      max: Number(profile.max || 0) + Number(transit.max || 0)
    };
  }

  let lastSnapshotSig = '';
  let snapshotTimer = null;

  function persistCartSnapshot(snapshot) {
    if (!CART_SNAPSHOT_ENABLED || !snapshot || !window.fetch) return;
    const sig = [
      snapshot.range,
      snapshot.minDate,
      snapshot.maxDate,
      snapshot.profile,
      snapshot.country
    ].join('|');
    if (!sig || sig === lastSnapshotSig) return;
    lastSnapshotSig = sig;
    try {
      if (window.sessionStorage && window.sessionStorage.getItem('nb_delivery_promise_sig') === sig) return;
    } catch (e) {}
    if (snapshotTimer) clearTimeout(snapshotTimer);
    snapshotTimer = setTimeout(() => {
      snapshotTimer = null;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            nb_delivery_promise_range: snapshot.range,
            nb_delivery_promise_min_date: snapshot.minDate,
            nb_delivery_promise_max_date: snapshot.maxDate,
            nb_delivery_promise_profile: snapshot.profile,
            nb_delivery_promise_country: snapshot.country,
            nb_delivery_promise_calculated_at: snapshot.calculatedAt,
            nb_delivery_promise_version: SNAPSHOT_VERSION
          }
        })
      })
        .then((response) => {
          if (!response || !response.ok) return;
          try {
            if (window.sessionStorage) window.sessionStorage.setItem('nb_delivery_promise_sig', sig);
          } catch (e) {}
        })
        .catch(() => {});
    }, 120);
  }

  async function initOne(container) {
    if (!container) return;
    const titleEl = container.querySelector('[data-role="title"]');
    const valueEl = container.querySelector('[data-role="between"]');
    const tlWrap = container.querySelector('[data-role="timeline"]');
    const leftEl = container.querySelector('[data-role="leftDate"]');
    const rightEl = container.querySelector('[data-role="rightDate"]');
    const noteEl = container.querySelector('[data-role="note"]');
    const card = container.querySelector('.delivery-card, .cart-exp-delivery__card');
    if (!titleEl || !valueEl) return;

    const profileKey = String(container.getAttribute('data-profile-key') || 'STANDARD').toUpperCase();
    const langRaw = container.getAttribute('data-lang') || 'en';
    const country = String(container.getAttribute('data-country') || 'DEFAULT').toUpperCase();
    const L = i18n[pickLang(langRaw)] || i18n.en;
    const config = await loadConfig();
    const sig = `${profileKey}|${langRaw}|${country}|${JSON.stringify(config.profiles[profileKey] || config.profiles.STANDARD)}|${JSON.stringify(config.transit[country] || config.transit.DEFAULT)}`;
    if (container.dataset.nbSig === sig) return;
    container.dataset.nbSig = sig;

    titleEl.textContent = L.title || L.title || L.label;
    valueEl.textContent = L.calculating || '';

    const cfg = promiseFor(profileKey, country, config);
    const now = nowInTZ(TZ);
    const cal = makeCalendar(now);
    let base = new Date(now);
    if (now.getHours() >= CUT_OFF_HOUR) base.setDate(base.getDate() + 1);
    base = cal.isBusiness(base) ? base : cal.nextBusinessDay(base);

    const minDate = cal.addBusinessDaysFrom(base, cfg.min);
    const maxDate = cal.addBusinessDaysFrom(base, cfg.max);
    const rangeTxt = `${fmtDM(minDate)}–${fmtDM(maxDate)}`;
    valueEl.textContent = `${L.between} ${rangeTxt}`;

    persistCartSnapshot({
      range: rangeTxt,
      minDate: fmtISODate(minDate),
      maxDate: fmtISODate(maxDate),
      profile: profileKey,
      country,
      calculatedAt: new Date().toISOString()
    });

    if (tlWrap && leftEl && rightEl) {
      tlWrap.style.display = '';
      leftEl.textContent = fmtDM(base);
      rightEl.textContent = rangeTxt;
      if (card) card.classList.add('nb-anim');
    }

    if (noteEl) {
      if (profileKey === 'BTS' && L.bts_note) {
        noteEl.textContent = L.bts_note;
        noteEl.style.display = '';
      } else {
        noteEl.textContent = '';
        noteEl.style.display = 'none';
      }
    }
  }

  let rafId = null;
  function initAll(retryFrames = 10) {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      const nodes = document.querySelectorAll(SELECTOR);
      if (nodes && nodes.length) nodes.forEach(initOne);
      else if (retryFrames > 0) initAll(retryFrames - 1);
    });
  }

  window.NBCartExpectedDeliveryInit = initAll;
  initAll(10);
  document.addEventListener('DOMContentLoaded', () => initAll(10));
  window.addEventListener('load', () => initAll(20));
  document.addEventListener('dispatch:cart-expected-delivery:init', () => initAll(10));
  document.addEventListener('shopify:section:load', () => initAll(10));
  document.addEventListener('cart:updated', () => initAll(20));
  document.addEventListener('cart:refresh', () => initAll(20));
  document.addEventListener('cart:change', () => initAll(20));
  document.addEventListener('ajaxCart.afterCartLoad', () => initAll(20));
  document.addEventListener('click', (event) => {
    const trigger = event.target && event.target.closest
      ? event.target.closest('a[href="/cart"], [href$="/cart"], [data-cart-drawer], [data-cart-toggle], [aria-controls*="cart"], .cart-link, .header__icon--cart')
      : null;
    if (trigger) {
      setTimeout(() => initAll(30), 0);
      setTimeout(() => initAll(30), 250);
      setTimeout(() => initAll(30), 900);
    }
  }, true);

  function mutationTouchesDelivery(mutations) {
    if (!mutations || !mutations.length) return false;
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      if (mutation.target && mutation.target.nodeType === 1) {
        const target = mutation.target;
        if (target.matches && target.matches(SELECTOR)) return true;
      }
      const nodes = mutation.addedNodes || [];
      for (let j = 0; j < nodes.length; j++) {
        const node = nodes[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.matches && node.matches(SELECTOR)) return true;
        if (node.querySelector && node.querySelector(SELECTOR)) return true;
      }
    }
    return false;
  }

  if (!window.__nbCartDeliveryPromiseObserver) {
    window.__nbCartDeliveryPromiseObserver = new MutationObserver((mutations) => {
      if (mutationTouchesDelivery(mutations)) initAll(6);
    });
    window.__nbCartDeliveryPromiseObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
